import script from "./MainHeader.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./MainHeader.vue?vue&type=script&setup=true&async=true&lang=js"

const __exports__ = script;

export default __exports__